import React, { useContext, useMemo } from 'react';
import StepsProvider from 'providers/Steps/Steps.provider';
import { Outlet } from 'react-router';
import ListingCreationStepper from '../../../components/ListingCreationStepper';
import routes from './routes';
import LcwStepWrapper from '../../../components/LcwStepWrapper';
import ListingContext from '../../../providers/Listing/Listing.context';
import CircleStepper from '../../../components/CircleStepper';
import { useLocation } from 'react-router-dom';
import PatchListingProvider from 'router/subrouters/ListingCreationWizard/providers/PatchListing';

const ProfitableGoingConcern: React.FC = () => {
  const { pathname } = useLocation();

  const stepperRoutes = useMemo(
    () => routes.filter((route) => route.labelId),
    [],
  );

  const isTeaserActive = pathname.includes('teaser');

  const { completedSteps } = useContext(ListingContext);

  return (
    <StepsProvider
      steps={stepperRoutes}
      storageKeySuffix="listing-creation-wizard-steps"
      completedSteps={completedSteps}
    >
      {!isTeaserActive && (
        <>
          <ListingCreationStepper />
          <CircleStepper />
        </>
      )}
      <LcwStepWrapper>
        <PatchListingProvider>
          <Outlet />
        </PatchListingProvider>
      </LcwStepWrapper>
    </StepsProvider>
  );
};

export default ProfitableGoingConcern;
